module.exports = __webpack_public_path__ + "img/TractionAndroid.43f474bf.svg";